module.exports = __webpack_public_path__ + "static/media/bmo-onguard-ida-logo-FR.0f14fb75.svg";